import { render } from "./AppTabs.vue?vue&type=template&id=3f6b4edb&scoped=true"
import script from "./AppTabs.vue?vue&type=script&lang=js"
export * from "./AppTabs.vue?vue&type=script&lang=js"

import "./AppTabs.vue?vue&type=style&index=0&id=3f6b4edb&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f6b4edb"]])

export default __exports__